import { render } from "./trans.vue?vue&type=template&id=00583dd4&scoped=true"
import script from "./trans.vue?vue&type=script&lang=js"
export * from "./trans.vue?vue&type=script&lang=js"

import "./trans.vue?vue&type=style&index=0&id=00583dd4&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00583dd4"]])

export default __exports__